import React from 'react';
import AppHeader from '../components/AppHeader.js';
import UserAvatar from '../components/UserAvatar.js';

const infoItems = [
	{
		id: 1,
		content: 'Vstup na vlastní nebezpečí'
	},
	{
		id: 2,
		content: 'Prostor je hlídaný kamerou se záznamem'
	},
	{
		id: 3,
		content: (
			<>
				Pro členy mladší 15 let je vstup povolen pouze se souhlasem zákonného zástupce. Potvrzení je možné stáhnout{' '}
				<a className="rule-page__link" href="../../docs/souhlas_zakonneho_zastupce.pdf" target="_blank" rel="noopener noreferrer">
					zde <img className="icon1 pdf" alt="" />
				</a>
			</>
		)
	}
];

const operationItems = [
	{
		id: 1,
		content: 'ZÁKAZ VSTUPU osobám neregistrovaným a nezapsaným na příslušný den a hodinu. Výjimku tvoří pouze doprovody, které jsou tam vždy pouze s registrovanou osobou. Permanentka je nepřenosná.'
	},
	{
		id: 2,
		content: 'Přístup do Progress Gymu a aplikace je pro aktivní členy, kteří chodí cvičit. Pokud nechodíš cvičit, bude ti po dvou měsících aplikace deaktivována a klíč od dveří zrušen.'
	},
	{
		id: 3,
		content: 'Rezervuj si v apce termín před vstupem do fitka. Pokud nepřijdeš na rezervovaný termín, zruš ho v apce, ať neblokuješ místo ostatním.'
	},
	{
		id: 4,
		content: 'Přezouvat (zákaz vstupu v botách, ve kterých jste přišli z venku).'
	},
	{
		id: 5,
		content: 'Zavírat vrata a okna, zamykat dveře při odchodu (pokud odcházíš jako poslední).'
	},
	{
		id: 6,
		content: 'Všude vypnout světla (pokud odcházíš jako poslední).'
	},
	{
		id: 7,
		content: 'Uklízet po sobě nářadí, činky, kotouče, nádobí, odpadky.'
	},
	{
		id: 8,
		content: 'Po použití sprchy vždy otevřít okno a zavřít dveře od koupelny.'
	},
	{
		id: 9,
		content: 'Nemanipulovat s topením.'
	},
	{
		id: 10,
		content: 'Zákaz kouření (všeho druhu).'
	},
	{
		id: 11,
		content: 'Parkovat pouze u fitka (co nejblíže k budově), rozhodně ne u bytovek nad fitkem. Pouze pod vyznačenou červenou čarou.'
	},
	{
		id: 12,
		content: 'Po 22. hodině dodržovat noční klid (zakázáno používat hlasitou hudbu nebo jiný hlasitý zvuk).'
	},
	{
		id: 13,
		content: 'Pokud si vezmeš drink nebo něco jiného, vždy to musí být přidáno v e-shopu.'
	},
	{
		id: 14,
		content: 'U jednorázových vstupů je třeba vyrovnat účet (vstup, doprovody, nákup v e-shopu) před odchodem z fitka.'
	},
	{
		id: 15,
		content: 'U permanentek je třeba vyrovnat účet (doprovody, nákup v e-shopu) ihned po uplynutí platnosti permanentky.'
	}
];

const contactItems = [
	{
		label: 'Roman',
		value: '+420 605 359 072',
		href: 'tel:+420605359072',
		photoUrl: '/images/usr/1/profilephoto.jpg'
	},
	{
		label: 'Peter',
		value: '+420 775 096 383',
		href: 'tel:+420775096383',
		photoUrl: '/images/usr/4/profilephoto.jpg'
	},
	{
		label: 'Adresa',
		value: 'Návsí 1160',
		href: 'https://mapy.cz/s/dejofonoko',
		external: true
	}
];

const renderListItem = ({id, content}) => (
	<div key={id} className="rule-page__item">
		<div className="rule-page__item-number">{id}.</div>
		<div className="rule-page__item-text">{content}</div>
	</div>
);

export default function Rule({usrInfo, timerCnt}) {
	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={false} />

				<div className={`page rule-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="rule-page__shell">
						<section className="rule-page__section">
							<div className="rule-page__section-head">
								<h2 className="rule-page__section-title">Info</h2>
							</div>
							<div className="rule-page__list">{infoItems.map(renderListItem)}</div>
						</section>

						<section className="rule-page__section">
							<div className="rule-page__section-head">
								<h2 className="rule-page__section-title">Jak to u nás funguje</h2>
							</div>
							<div className="rule-page__list">{operationItems.map(renderListItem)}</div>
						</section>

						<section className="rule-page__section">
							<div className="rule-page__section-head">
								<h2 className="rule-page__section-title">Když potřebuješ pomoct</h2>
							</div>
							<div className="rule-page__contact-grid">
								{contactItems.map((contact) => (
									<a
										key={contact.label}
										className="rule-page__contact-card"
										href={contact.href}
										target={contact.external ? '_blank' : undefined}
										rel={contact.external ? 'noopener noreferrer' : undefined}
									>
										{contact.photoUrl ? <UserAvatar photoUrl={contact.photoUrl} displayName={contact.label} className="rule-page__contact-avatar" /> : null}
										<span className="rule-page__contact-text">
											<span className="rule-page__contact-label">{contact.label}</span>
											<span className="rule-page__contact-value">{contact.value}</span>
										</span>
									</a>
								))}
							</div>
						</section>
					</div>
				</div>
			</div>
		</>
	);
}
